"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DISABLED_ITEM_CLASS = exports.itemControls = exports.movementIncrement = exports.inputTypes = exports.actions = void 0;

/**
 *
 * @type {{MOVEDOWN: string, REMOVE: string, MOVEUP: string}}
 */
var actions = {
  MOVEDOWN: 'down',
  MOVEUP: 'up',
  REMOVE: 'remove'
};
/**
 * @desc
 * Input types.
 *
 * @enum
 *
 * @type {{DEFAULT: string, IPv4: string, IPv6: string}}
 */

exports.actions = actions;
var inputTypes = {
  DEFAULT: 'default',
  IPv4: 'ipv4',
  IPv6: 'ipv6'
};
exports.inputTypes = inputTypes;
var movementIncrement = {
  MOVE_UP: -1,
  MOVE_DOWN: 1
};
exports.movementIncrement = movementIncrement;
var itemControls = {
  DISABLED: 'disabled',
  HIDDEN: 'hidden'
};
exports.itemControls = itemControls;
var DISABLED_ITEM_CLASS = 'item-control-disabled';
exports.DISABLED_ITEM_CLASS = DISABLED_ITEM_CLASS;
//# sourceMappingURL=constants.js.map